import { Button } from 'antd';
import calendarPng from 'assets/images/calendar.png';
import arrowPng from 'assets/images/arrow-blue.png';
import React, { useEffect, useState } from 'react';
import ModalEndSubmit from '../../../Organisms/Modals/ModalEndSubmit/ModalEndSubmit';
import { TaskState } from '../../../../../../gql/graphql';
import StateTag from '../../Tags/StateTag/StateTag';
import InputUploadedFile from '../../Inputs/InputUploadedFile/InputUploadedFile';
import UploadDocs from '../../UploadDocs/UploadDocs';

interface Props {
  title: string;
  titleLocation?: 'outside' | 'inside' | undefined;
  description?: string;
  isButtonSample?: { show: boolean; link: string };
  isButtonTemplate?: { show: boolean; link: string };
  submit?: {
    title: string;
    confirmDescription?: string;
    modalConfirm?: boolean;
    loading: boolean;
    onClick: (files: File[]) => void;
    location?: 'outside' | 'inside' | undefined;
    disabled?: boolean;
    hidden?: boolean;
  };
  hasDropdown?: boolean;
  limitFiles?: number;
  files?: File[] | any;
  state?: TaskState;
  hiddenTagDraft?: boolean;
  actionDeleteFile?: any;
  onChangeFiles?: any;
  insertHtml?: any;
  onDeleteFile?: boolean;
}

const CardUploadResponse = ({
  title,
  titleLocation,
  description,
  isButtonSample,
  isButtonTemplate,
  submit,
  hasDropdown = false,
  limitFiles = 1,
  files,
  state,
  actionDeleteFile,
  onChangeFiles,
  hiddenTagDraft,
  insertHtml,
  onDeleteFile
}: Props) => {

  const [listFileUpload, setListFileUpload] = useState([]);
  const [isModalSubmit, setModalSubmit] = useState(false);

  useEffect(() => {
    setListFileUpload(files || [])
  }, [files])

  useEffect(() => {
    if(onDeleteFile) setListFileUpload([]);
  }, [onDeleteFile])

  useEffect(() => {
    if (onChangeFiles) onChangeFiles(listFileUpload);
  }, [listFileUpload]);

  const onSubmit = () => {
    if (submit?.modalConfirm) setModalSubmit(true);
    else submit?.onClick(listFileUpload);
  };

  return (
    <>
      {titleLocation === 'outside' &&
        <span className="h4">{title}</span>
      }
      <div
        className={`card-upload-response card-upload-response-${state}`}
        style={{ marginTop: titleLocation === 'outside' ? 10 : 0 }}
      >
        {insertHtml}

        {state && (state !== TaskState.Review && !hiddenTagDraft) && <StateTag state={state} />}
        {state && (state === TaskState.Review) && <StateTag state={state} isLabelLocked />}

        {(title || isButtonSample) &&
          <div className="header" style={{ marginTop: !isButtonSample ? 10 : 0 }}>
            {!titleLocation && <span className="h4">{title}</span>}
            {isButtonSample?.show && (
              <Button type="link" className="link">
                See sample
              </Button>
            )}
          </div>
        }
        <div className="description">{description}</div>
        {isButtonTemplate?.show && (
          <div className="template">
            <Button type="link" className="button button-blue">
              Download template
            </Button>
            <img src={arrowPng} className="arrow-right" alt="arrow" />
          </div>
        )}
        <div className="section-upload">
          {files && (
            <div className="cont-files">
              {files?.map((file: any, index: number) => (
                <InputUploadedFile
                  key={index}
                  file={file}
                  isActionSeeFile
                  state={state ? file.state : null}
                  deleteFile={actionDeleteFile}
                />
              ))}
            </div>
          )}

          {(!files || files?.length === 0 || state === TaskState.RequestError) && (
            <UploadDocs
              numberOfFiles={limitFiles}
              button={
                submit && (!submit.location || submit.location === 'inside') ? (
                  <Button
                    className="button button-submit"
                    loading={submit.loading}
                    disabled={listFileUpload.length === 0 || submit.disabled}
                    onClick={onSubmit}
                  >
                    {submit.title}
                  </Button>
                ) : null
              }
              listFileUpload={listFileUpload}
              setListFileUpload={setListFileUpload}
            />
          )}
        </div>


        {!submit?.hidden && submit?.modalConfirm && (
          <ModalEndSubmit
            visible={isModalSubmit}
            setVisible={setModalSubmit}
            buttonAction={{
              hidden: true
            }}
            modal={{
              title: 'Ready to submit?',
              description: submit?.confirmDescription ? (
                <h4 className="h4 h4-w4">{submit?.confirmDescription}</h4>
              ) : undefined
            }}
            buttonSubmit={
              <Button
                className="button button-modal-ok"
                onClick={() => {
                  setModalSubmit(false);
                  submit.onClick(listFileUpload)
                }}
                loading={submit.loading}
              >
                Yes, this is correct
              </Button>
            }
            buttonCancel={(actionCancel: any) => (
              <Button
                className="button button-modal-cancel"
                onClick={actionCancel}
              >
                I want to make changes
              </Button>
            )}
            icon={calendarPng}
            className="modal-end-submit--white"
          />
        )}
      </div>
      {!submit?.hidden && submit?.location === 'outside' && (
        <div className="mt-20">
          <Button
            className="button button-submit"
            loading={submit?.loading}
            disabled={
              (!hasDropdown && listFileUpload.length === 0) || submit.disabled}
            onClick={onSubmit}
          >
            {submit?.title}
          </Button>
        </div>
      )}
    </>
  );
};
export default CardUploadResponse;
